/**
 * @generated SignedSource<<0f444785cff56599d02a72e9fe1edd29>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type LinkListGroup_frontGroup$data = {
  readonly linkLists: ReadonlyArray<{
    readonly " $fragmentSpreads": FragmentRefs<"LinkList_linkList">;
  }>;
  readonly title: string;
  readonly " $fragmentType": "LinkListGroup_frontGroup";
};
export type LinkListGroup_frontGroup$key = {
  readonly " $data"?: LinkListGroup_frontGroup$data;
  readonly " $fragmentSpreads": FragmentRefs<"LinkListGroup_frontGroup">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "LinkListGroup_frontGroup",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "LinkList",
      "kind": "LinkedField",
      "name": "linkLists",
      "plural": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "LinkList_linkList"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "LinkListGroup",
  "abstractKey": null
};

(node as any).hash = "0eec4d62cdd154e11707fea540348499";

export default node;
